import Div from "@jumbo/shared/Div/Div";

const SidebarTagsWrapper = ({children, active, component}) => {
    return (
        <Div
            sx={{
                paddingRight: active ? "200px" : 0,
                transition: "padding .3s ease-in-out"
            }}
        >
            {children}
            {active && component}
        </Div>
    );
};

export default SidebarTagsWrapper;